import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 add_module_to_tenant: { message: "idle" },
};

export const add_module_to_tenant_Slice = createSlice({
 name: "add_module_to_tenant",
 initialState,
 reducers: {
  success_add_module_to_tenant: (state, action) => {
   state.add_module_to_tenant = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_add_module_to_tenant: (state, action) => {
   state.add_module_to_tenant = { status: app_consts.FAIL, message: action.payload };
  },
  reset_add_module_to_tenant: (state) => {
   state.add_module_to_tenant = { status: app_consts.IDLE };
  },
  loading_add_module_to_tenant: (state) => {
   state.add_module_to_tenant = { status: app_consts.LOADING };
  },
 }
});

export const { success_add_module_to_tenant, fail_add_module_to_tenant, reset_add_module_to_tenant, loading_add_module_to_tenant } = add_module_to_tenant_Slice.actions;

export default add_module_to_tenant_Slice.reducer;